import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'resolutions-skeleton',
  templateUrl: './resolutions-skeleton.component.html',
  styleUrls: ['./resolutions-skeleton.component.scss']
})
export class ResolutionsSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
